import React from "react";
import { Container } from "react-bootstrap";
import "./HowItWorks.css";

const steps = [
  {
    title: "Choisissez votre démarche",
    text: "Création d'entreprise, domiciliation, gestion ou formalité : sélectionnez le service qui correspond à votre besoin.",
  },
  {
    title: "Identifiez-vous en quelques secondes",
    text: "Pas de mot de passe à retenir : vous recevez un code de connexion à usage unique par e-mail ou par SMS.",
  },
  {
    title: "Complétez votre dossier",
    text: "Répondez à quelques questions et envoyez vos documents en ligne (PDF, JPG ou PNG). La liste des pièces s'adapte à votre démarche.",
  },
  {
    title: "Réglez par Mobile Money",
    text: "Payez avec MTN Mobile Money ou Orange Money. Vous validez la transaction directement sur votre téléphone.",
  },
  {
    title: "Suivez l'avancement",
    text: "Un conseiller prend en charge votre dossier. Vous suivez chaque étape depuis votre espace et récupérez vos documents officiels.",
  },
];

function HowItWorks() {
  return (
    <section id="how-it-works" className="hiw" aria-labelledby="hiw-title">
      <Container>
        <header className="hiw-header">
          <p className="eyebrow mb-2">Comment ça marche</p>
          <h2 id="hiw-title" className="hiw-title">
            Vos démarches en ligne, en cinq étapes
          </h2>
          <p className="hiw-lead">
            Vous n'avez pas besoin de vous déplacer : tout se fait depuis votre
            ordinateur ou votre téléphone.
          </p>
        </header>

        <ol className="hiw-steps">
          {steps.map((step, index) => (
            <li key={step.title} className="hiw-step">
              <span className="hiw-number" aria-hidden="true">
                {index + 1}
              </span>
              <h3 className="hiw-step-title">{step.title}</h3>
              <p className="hiw-step-text">{step.text}</p>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}

export default HowItWorks;
